import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
    transform(text: string, length: number) {
        if (text && text.length > length) {
            return text.slice(0, length) + '...';
        }

        return text;
    }
}
